import hostedGrafana from "public/application-services/icons/hosted-grafana.png";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_GRAFANA_FEATURES = {
  title: "Features of Hosted Grafana",
  list: [
    {
      image: hostedGrafana,
      title: "Scalability, Flexibility & Expert Management",
      content: (
        <ContentCard
          points={[
            "Elastic scalability to adjust resources for varying data and user loads efficiently.",
            "Flexible configurations tailored to business needs, including cloud provider choices.",
            "Managed services & technical assistance for monitoring, optimization, and troubleshooting.",
          ]}
        />
      ),
    },
    {
      image: hostedGrafana,
      title: "High Availability & Performance",
      content: (
        <ContentCard
          points={[
            "Redundancy & failover mechanisms to ensure continuous data access.",
            "Optimized infrastructure for low-latency data retrieval and dashboard rendering.",
          ]}
        />
      ),
    },
    {
      image: hostedGrafana,
      title: "Robust Security",
      content: (
        <ContentCard
          points={[
            "Data encryption at rest and in transit for compliance and protection.",
            "Fine-grained access controls to restrict data visibility and user actions.",
          ]}
        />
      ),
    },
    {
      image: hostedGrafana,
      title: "Seamless Integration",
      content: (
        <ContentCard
          points={[
            "API access for effortless integration with various data sources and applications.",
            "Ecosystem compatibility with a wide range of plugins and Grafana tools.",
          ]}
        />
      ),
    },
  ],
};
